import React from "react";
import styles from "./LicznikCzasu.module.css";
import {
    OPOZNIENIE_LICZNIKA_MS,
    PROG_DLUGIEGO_LADOWANIA_MS,
    formatujCzasLadowania,
    useUplywCzasu,
} from "./czasLadowania";

/**
 * [S19 2026-09-14] Czas trwania ładowania („1,2 s”).
 *
 * Pokazuje się dopiero po {@link OPOZNIENIE_LICZNIKA_MS} — szybkie zapytania nie migają cyferkami.
 * Po {@link PROG_DLUGIEGO_LADOWANIA_MS} dopisuje „Trwa dłużej niż zwykle…”.
 * Same cyfry są UKRYTE przed czytnikiem ekranu (zmieniają się co 100 ms — w regionie `aria-live` czytnik
 * powtarzałby je bez końca); dopisek o długim ładowaniu jest czytany, bo pojawia się raz.
 *
 * @param {object} props
 * @param {number|null} [props.startedAt] początek ładowania (Date.now()); licznik sam tyka
 * @param {number} [props.uplywMs] upływ policzony przez rodzica — wtedy komponent NIE uruchamia własnego zegara
 * @param {string} [props.className]
 */
const LicznikCzasu = ({ startedAt = null, uplywMs, className = "" }) => {
    const podany = Number.isFinite(uplywMs);
    const wlasny = useUplywCzasu(podany ? null : startedAt);
    const uplyw = podany ? uplywMs : wlasny;

    if ((!podany && startedAt == null) || uplyw < OPOZNIENIE_LICZNIKA_MS) return null;

    return (
        <span className={`${styles.licznik} ${className}`.trim()} data-licznik-czasu="">
            <span className={styles.cyfry} aria-hidden="true">{formatujCzasLadowania(uplyw)}</span>
            {uplyw >= PROG_DLUGIEGO_LADOWANIA_MS && (
                <span className={styles.dopisek}>Trwa dłużej niż zwykle…</span>
            )}
        </span>
    );
};

export default LicznikCzasu;
